<script setup>
import { inject } from 'vue';
import { __, updateURL } from '@/utils';

const props = defineProps({
	steps: Object,
	iconType: String,
	showBackBtn: Boolean,
	blockedStep: Number
});

const { prevStep, setActiveStep, activeStep, isTargetStepValid } = inject('step');
const { validate } = inject('form');

const handleBack = () => {
	const stepNumber = prevStep();
	setActiveStep(stepNumber);
}

if(activeStep.value <= 4) {
	updateURL(`#step${activeStep.value}`);
} 

const handleClick = async (value) => {
	const prevStep = value - 1;
	const validTargetStep = prevStep === 0 ? true : isTargetStepValid(prevStep);

	if(props.blockedStep != value){
		if(value > activeStep.value) {
			const { valid } = await validate();
			if(valid && validTargetStep) {
				setActiveStep(value)
				updateURL(`#step${value}`);
			}
		} else if(validTargetStep) {
			setActiveStep(value)
			updateURL(`#step${value}`);
		}
	}
}

const stepImageSrc = (index) => {
	return theme_path.url + '/resources/images/' + props.iconType + '-' + index;
}
</script>
<template>
	<div class="form__nav">
		<nav class="nav-steps">
			<div class="nav-steps__back" v-if="activeStep !== 1 && showBackBtn">
				<button class="btn-circle-icon" type="button" @click="handleBack">
					<i class="ico ico--arrow-right"></i>
				</button>
			</div>
			<ul>
				<li v-for="(step, index) in steps" :key="index" :class="{ 'is-active': activeStep === index + 1 }">
					<a href="#" @click.prevent="handleClick(index + 1)"></a>

					<figure>
						<img :src="stepImageSrc(index + 1) + '-light.svg'" alt="">
						<img :src="stepImageSrc(index + 1) + '.svg'" alt="">
					</figure>

					<h6>
						<span>
							{{ step.title }}
						</span>
					</h6>
				</li>
			</ul>

			<h6 class="step-number-header"><span class="gradient">0{{ activeStep }}</span>{{ steps.find((_, index) => activeStep === index + 1)?.title }}</h6>
		</nav><!-- /.nav-steps -->
	</div><!-- /.form__nav -->
</template>
